import { connect } from 'react-redux';
import DashboardManager from './DashboardManager';
const mapStateToProps = (state) => ({
    iss: state.roles.iss,
});
export default connect(mapStateToProps)(DashboardManager);
